import React from 'react';
import './LetterBank.css';

const LetterBank = ({ tiles, usedTileIds = new Set(), onTileClick }) => {
  if (!tiles) return null;

  // Group tiles by type and direction
  const singleTiles = tiles.filter(tile => tile.type === 'single');
  const doubleTiles = tiles.filter(tile => tile.type === 'double');
  const tripleTiles = tiles.filter(tile => tile.type === 'triple');

  // Separate triple vertical tiles
  const tripleVerticalTiles = tripleTiles.filter(tile => tile.direction === 'vertical');
  const hasTripleVertical = tripleVerticalTiles.length > 0;

  // Group double horizontal, double vertical, and triple horizontal tiles
  const groupedDoubleTripleTiles = [
    ...doubleTiles,
    ...tripleTiles.filter(tile => tile.direction === 'horizontal')
  ];

  return (
    <div className="letter-bank-container">
      <div className="letter-bank">
        {/* Single Tiles Section */}
        {singleTiles.length > 0 && (
          <div className="tile-section single-tiles">
            <div className="tile-group">
              {singleTiles.map((tile) => (
                <div
                  key={tile.id}
                  className={`letter-tile ${tile.type} ${tile.direction ? `${tile.type}-${tile.direction}` : ''} ${usedTileIds.has(tile.id) ? 'used' : ''} tile-border`.trim()}
                  onClick={() => !usedTileIds.has(tile.id) && onTileClick(tile)}
                >
                  {tile.letters.map((letter, index) => (
                    <span key={index} className="tile-letter">
                      {letter}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Double & Triple Horizontal/Vertical Tiles Section */}
        {groupedDoubleTripleTiles.length > 0 && (
          <div className="tile-section double-triple-tiles">
            <div className="tile-group">
              {groupedDoubleTripleTiles.map((tile) => (
                <div
                  key={tile.id}
                  className={`letter-tile ${tile.type} ${tile.direction ? `${tile.type}-${tile.direction}` : ''} ${usedTileIds.has(tile.id) ? 'used' : ''} tile-border`.trim()}
                  onClick={() => !usedTileIds.has(tile.id) && onTileClick(tile)}
                >
                  {tile.letters.map((letter, index) => (
                    <span key={index} className="tile-letter">
                      {letter}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Triple Vertical Tiles Section */}
      {hasTripleVertical && (
        <div className="triple-vertical-section">
          <div className="tile-group">
            {tripleVerticalTiles.map((tile) => (
              <div
                key={tile.id}
                className={`letter-tile ${tile.type} ${tile.direction ? `${tile.type}-${tile.direction}` : ''} ${usedTileIds.has(tile.id) ? 'used' : ''} tile-border`.trim()}
                onClick={() => !usedTileIds.has(tile.id) && onTileClick(tile)}
              >
                {tile.letters.map((letter, index) => (
                  <span key={index} className="tile-letter">
                    {letter}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LetterBank;